var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 9,
    cy: 9,
    r: 9,
    transform: "matrix(-1 0 0 1 18 0)",
    fill: "#2C2B38"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8405 13.9748C12.0532 14.2088 12.0532 14.5883 11.8405 14.8237C11.7341 14.9407 11.595 14.9992 11.4545 14.9992C11.3141 14.9992 11.175 14.9407 11.0686 14.8237L6.15955 9.42409C5.94682 9.1901 5.94682 8.81063 6.15955 8.57514L11.0686 3.17549C11.2814 2.9415 11.6264 2.9415 11.8405 3.17549C12.0545 3.40947 12.0532 3.78895 11.8405 4.02443L7.31727 8.99961L11.8405 13.9748Z",
    fill: "#2C2B38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.0fc13de8dafb7cf52533132a9e24e8c6.svg";
export { ForwardRef as ReactComponent };